"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/AuthLayout/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    AuthBackground_template = require("../AuthBackground.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    AuthBackground_tag = marko_loadTag(AuthBackground_template),
    TenantLogo_template = require("../../../components/TenantLogo/index.marko"),
    TenantLogo_tag = marko_loadTag(TenantLogo_template),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Footer_Public_template = require("../Footer-Public.marko"),
    Footer_Public_tag = marko_loadTag(Footer_Public_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "d-flex height-100vh justify-content-center align-items-center center animated fast fadeIn"
      },
    marko_attrs1 = {
        "class": "position-fixed px-3 py-2"
      },
    marko_attrs2 = {
        "class": "theme-bg-transparent border rounded p-2 col-xl-4 col-lg-5 col-md-6 col-10"
      },
    marko_attrs3 = {
        "class": "card-content"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      scroll: true,
      renderBody: function(out) {
        AuthBackground_tag({}, out, __component, "1");

        if (input.showLogo) {
          out.be("div", marko_attrs1, "2", component);

          TenantLogo_tag({}, out, __component, "3");

          out.ee();
        }

        out.be("section", marko_attrs0, "4", component);

        Row_tag({
            class: "w-100 d-flex justify-content-center",
            renderBody: function(out) {
              out.be("div", marko_attrs2, "6", component);

              out.be("div", marko_attrs3, "7", component);

              marko_dynamicTag(out, input.renderBody, null, null, null, null, __component, "8");

              out.ee();

              out.ee();
            }
          }, out, __component, "5");

        out.ee();

        Footer_Public_tag({}, out, __component, "9");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
